
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]",
      function () {
        return require("private-next-pages/[region]/[lang]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]"])
      });
    }
  